import type { MentionComposeElement } from '../useEmailMentionAssist';

export function insertTextAtComposeCaret(input: MentionComposeElement, text: string): string {
  const value = input.value ?? '';
  const start = input.selectionStart ?? value.length;
  const end = input.selectionEnd ?? start;
  const next = `${value.slice(0, start)}${text}${value.slice(end)}`;
  input.value = next;
  const caret = start + text.length;
  try {
    input.setSelectionRange(caret, caret);
  } catch {
    /* ignored: some inputs may not support selection range */
  }
  input.focus();
  input.dispatchEvent(new Event('input', { bubbles: true }));
  return next;
}

